/**
 * Beacon analytics côté client.
 *
 * Stratégie :
 *   - On utilise navigator.sendBeacon quand c'est dispo (fire-and-forget,
 *     ne bloque pas la navigation, fonctionne même pendant unload).
 *   - Fallback fetch avec keepalive:true.
 *   - On ne tracke jamais :
 *       • si on est dans l'admin (path /dashboard/* ou /login)
 *       • si un JWT admin est présent dans localStorage (= utilisateur connecté)
 *       • si Do Not Track est activé
 */

const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const COLLECT_BASE = `${API_BASE}/api/pulse`;

function isPrivatePath(path) {
  return (
    path.startsWith('/dashboard') ||
    path.startsWith('/login') ||
    path.startsWith('/landing')
  );
}

function isAdminLogged() {
  try {
    return Boolean(localStorage.getItem('jwtToken'));
  } catch {
    return false;
  }
}

function isDoNotTrack() {
  return (
    typeof navigator !== 'undefined' &&
    (navigator.doNotTrack === '1' ||
      navigator.doNotTrack === 'yes' ||
      window.doNotTrack === '1')
  );
}

function shouldTrack(path) {
  if (typeof window === 'undefined') return false;
  if (isDoNotTrack()) return false;
  if (isAdminLogged()) return false;
  if (isPrivatePath(path)) return false;
  return true;
}

function post(endpoint, body) {
  const url = `${COLLECT_BASE}/${endpoint}`;
  const payload = JSON.stringify(body);
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([payload], { type: 'application/json' });
      const ok = navigator.sendBeacon(url, blob);
      if (ok) return;
    }
    // Fallback fetch keepalive
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {
      /* ignore */
    });
  } catch {
    /* ignore */
  }
}

export function trackPageview(path) {
  if (!shouldTrack(path)) return;
  post('hit', { path });
}

export function trackEvent(name, meta) {
  if (typeof window === 'undefined') return;
  if (isDoNotTrack()) return;
  if (isAdminLogged()) return;
  const path = window.location?.pathname || null;
  post('action', { name, path, meta });
}

const EVENTS = Object.freeze({
  CV_DOWNLOAD: 'cv_download',
  CONTACT_SUBMIT: 'contact_submit',
  NEWSLETTER_SUBSCRIBE: 'newsletter_subscribe',
});

export const AnalyticsEvents = EVENTS;
